import {Injectable} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {Observable} from 'rxjs';
import {IPacket} from './package.interface';
import {environment} from '../../environments/environment';
import {ICurrency} from "./currency.interface";

import {Locale} from "../core/lang.enum";

@Injectable()
export class PackageService {
  constructor(private http: HttpClient) {
  }

  list(): Observable<IPacket[]> {
    return this.http.get<IPacket[]>(`${environment.apiEndpoint}/packet`);
  }

  one(id: IPacket['id'], locale: Locale): Observable<IPacket> {
    return this.http.get<IPacket>(`${environment.apiEndpoint}/packet/${id}`, {
      params: {locale}
    });
  }

  update(id: IPacket['id'], body: Partial<IPacket>): Observable<IPacket> {
    return this.http.patch<IPacket>(`${environment.apiEndpoint}/packet/${id}`, body);
  }

  create(body: Partial<IPacket>): Observable<IPacket> {
    return this.http.post<IPacket>(`${environment.apiEndpoint}/packet`, body);
  }

  delete(id: IPacket['id']): Observable<any> {
    return this.http.delete(`${environment.apiEndpoint}/packet/${id}`);
  }

  getCurrency(id: IPacket['id']): Observable<ICurrency[]> {
    return this.http.get<any>(`${environment.apiEndpoint}/packet/${id}/price`);
  }

  updateCurrency(id: IPacket['id'], body: Pick<ICurrency, 'currency' | 'price'>): Observable<ICurrency> {
    return this.http.post<ICurrency>(`${environment.apiEndpoint}/packet/${id}/price`, body);
  }

  deleteCurrency(id: IPacket['id'], body: Pick<ICurrency, 'currency'>): Observable<any> {
    return this.http.delete<any>(`${environment.apiEndpoint}/packet/${id}/price`, {body});
  }

}
